import React from 'react';
import SelectSlide from '../SelectSlide/SelectSlide';
import { RelatedProductsFragment } from './RelatedProductSelector.gql';
/**
 * `RelatedProductSelector` is an implementation of `SelectSlide`, which displays a list of provided
 * related products with optional subtext, and emits a change event with the path of the selected product.
 */
var RelatedProductSelector = function (_a) {
    var currentProduct = _a.currentProduct, onChange = _a.onChange, relatedProducts = _a.relatedProducts, _b = _a.showSubcopy, showSubcopy = _b === void 0 ? true : _b;
    return (React.createElement(SelectSlide, { name: "related-product-selector", onChange: function (event, index) {
            var _a;
            (_a = window.heap) === null || _a === void 0 ? void 0 : _a.track('Related Product Selector Change', {
                optionTitle: relatedProducts[index].title
            });
            onChange(event.currentTarget.value);
        }, selectedOption: currentProduct, isFullWidth: true, optionPadding: "minimal" }, relatedProducts.map(function (related) { return (React.createElement(SelectSlide.Option, { key: related.product.url, value: related.product.url, label: related.title, subcopy: showSubcopy && related.subcopy
            ? { text: related.subcopy, isTwoLines: true }
            : undefined })); })));
};
RelatedProductSelector.fragment = RelatedProductsFragment;
export default RelatedProductSelector;
